import styled from 'styled-components';
import { Colors } from '@altermaind/web/ui';
import { convertSizeToNumber } from '@/_shared/helpers';
import { convertColorToRgba } from '@/_shared/helpers/convertColorToRgba';
import { WrappedInput } from '../WrappedInput';

export const StarsWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => `${convertSizeToNumber(theme?.sizes?.xxs || 6)}px`};
`;

export const StarButton = styled.button<{ active?: boolean }>`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    border-radius: 6px;
    box-shadow: ${({ theme }) =>
      `0 0 0 6px ${convertColorToRgba((theme.colors as Colors).primary || '#197EF7', 0.2)}`};
  }

  /* Mobile / touch: increase clickable area */
  @media (pointer: coarse) {
    /* on touch devices no hover-style: prefer active feedback */
    &:focus-visible {
      box-shadow: none;
    }
    &:active:not([disabled]) {
      transform: scale(0.98);
    }
  }
`;

export const HiddenInput = styled(WrappedInput).attrs({ type: 'hidden' })`
  display: none;
`;
